var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFossilFuels(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_115)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1004_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.098 220.152L451.282 219.968L382.772 151.458L363.25 170.98L402.109 209.839C382.772 217.206 369.696 236.912 373.011 259.748C375.958 280.007 393.269 296.397 413.527 298.607C422.183 299.528 429.734 298.055 436.917 294.924L436.917 446.125H400.083L400.083 308H344.833V142.25L160.667 142.25L160.667 473.75L344.833 473.75L344.833 335.625H372.458L372.458 473.566H464.542L464.542 252.75C464.542 240.042 459.385 228.44 451.098 220.152ZM308 271.167H197.5L197.5 179.083L308 179.083V271.167ZM418.5 271.167C408.371 271.167 400.083 262.879 400.083 252.75C400.083 242.621 408.371 234.333 418.5 234.333C428.629 234.333 436.917 242.621 436.917 252.75C436.917 262.879 428.629 271.167 418.5 271.167Z",
    fill: "#FCFCFC"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white",
    transform: "translate(108 108)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1004_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 442,
    height: 442,
    fill: "white",
    transform: "translate(87 87)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFossilFuels);
export default __webpack_public_path__ + "static/media/fossil-fuels.c13e71724e64ae78c49097bd20f1db31.svg";
export { ForwardRef as ReactComponent };